var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_16863",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_411_16863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5427 20.577L13.2619 14.2962C12.7619 14.7091 12.1869 15.0321 11.5369 15.2655C10.8869 15.4988 10.2145 15.6155 9.51965 15.6155C7.81048 15.6155 6.36396 15.0237 5.1801 13.8401C3.99623 12.6566 3.4043 11.2104 3.4043 9.50169C3.4043 7.79296 3.99608 6.34628 5.17965 5.16167C6.36321 3.97707 7.80936 3.38477 9.5181 3.38477C11.2268 3.38477 12.6735 3.9767 13.8581 5.16057C15.0427 6.34443 15.635 7.79095 15.635 9.50012C15.635 10.2142 15.5151 10.8963 15.2754 11.5463C15.0356 12.1963 14.7158 12.7617 14.3158 13.2424L20.5965 19.5232L19.5427 20.577ZM9.51965 14.1155C10.8081 14.1155 11.8995 13.6684 12.7937 12.7742C13.6879 11.8799 14.135 10.7886 14.135 9.50012C14.135 8.21165 13.6879 7.1203 12.7937 6.22607C11.8995 5.33183 10.8081 4.88472 9.51965 4.88472C8.23118 4.88472 7.13983 5.33183 6.2456 6.22607C5.35138 7.1203 4.90427 8.21165 4.90427 9.50012C4.90427 10.7886 5.35138 11.8799 6.2456 12.7742C7.13983 13.6684 8.23118 14.1155 9.51965 14.1155Z",
    fill: "#A1A5B7"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f017eaa5.svg";
export { ForwardRef as ReactComponent };